import { Button } from "antd";
import { Link } from "react-router-dom";

type PrimaryCta =
    | { label: string; to: string }
    | { label: string; onClick: () => void };

type Props = {
    eyebrow?: string;
    title: string;
    body?: string;
    primary?: PrimaryCta;
};

// Closing CTA shown at the bottom of long pages (most guides end with
// "Plan the route too — browse tours"). Visually distinct from feature
// or guide cards: tinted surface, primary button. The button can either
// route internally (`to`) or fire any handler (`onClick`) — the latter
// is used for the cross-origin Get-started hop into the app.
//
// Both variants render the same AntD <Button> so hover, focus, ripple
// and typography are identical; the routing variant wraps the button in
// a react-router <Link> for SPA navigation.
export default function CtaCard({ eyebrow, title, body, primary }: Props) {
    const button = primary && (
        <Button
            type="primary"
            size="large"
            onClick={"onClick" in primary ? primary.onClick : undefined}
        >
            {primary.label}
        </Button>
    );

    return (
        <aside className="gt-cta-card">
            {eyebrow && <div className="gt-eyebrow">{eyebrow}</div>}
            <h3 className="gt-h3 gt-cta-card__title">{title}</h3>
            {body && <p className="gt-cta-card__body">{body}</p>}
            {primary && "to" in primary ? (
                <Link to={primary.to} className="gt-cta-card__primary-link">
                    {button}
                </Link>
            ) : (
                button
            )}
        </aside>
    );
}
